// src/components/frequently-asked-questions/frequently-asked-questions.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment QuestionAndAnswerFragment on QuestionAndAnswer {\n    question\n    answer\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FrequentlyAskedQuestionsFragment on FrequentlyAskedQuestions {\n    title\n    questionsAndAnswers {\n      ...QuestionAndAnswerFragment\n    }\n    seeMore {\n      disabled\n      primary\n    }\n    seeLess {\n      disabled\n      primary\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FaqStructuredDataFragment on FrequentlyAskedQuestions {\n    seoStructuredData\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  query FrequentlyAskedQuestionsQuery($context: ContextInput!, $uriContextV1: UriContextInput!, $limit: Int!, $contentTopic: String) {\n    frequentlyAskedQuestions(context: $context, uriContextV1: $uriContextV1, limit: $limit, contentTopic: $contentTopic) {\n      ... on FrequentlyAskedQuestions {\n        id\n        ...FrequentlyAskedQuestionsFragment\n        ...FaqStructuredDataFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React5 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/frequently-asked-questions/__private/__fragments/faq.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkCard, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkExpandoList } from "uitk-react-expando";
import { UitkHeading } from "uitk-react-text";
// src/hooks/use-collapsed.tsx
import React from "react";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkCardContentSection } from "uitk-react-cards";
var Trigger = function(param) {
    var text = param.text, onClick = param.onClick;
    return /* @__PURE__ */ React.createElement(UitkCardContentSection, null, /* @__PURE__ */ React.createElement(UitkSecondaryButton, {
        isFullWidth: true,
        onClick: onClick
    }, text));
};
var useCollapsed = function(questionsAndAnswers, displayThreshold, seeMore, seeLess) {
    var faqs = questionsAndAnswers || [];
    var initialDisplayThreshold = displayThreshold > 0 ? displayThreshold : faqs === null || faqs === void 0 ? void 0 : faqs.length;
    var _React_useState = _slicedToArray(React.useState(initialDisplayThreshold), 2), numberOfFaqsToShow = _React_useState[0], setNumberOfFaqsToShow = _React_useState[1];
    var clickHandler = function() {
        var toSet = numberOfFaqsToShow === initialDisplayThreshold ? faqs.length : initialDisplayThreshold;
        setNumberOfFaqsToShow(toSet);
    };
    var isCollasped = numberOfFaqsToShow < (faqs === null || faqs === void 0 ? void 0 : faqs.length);
    return {
        items: faqs.slice(0, numberOfFaqsToShow),
        Trigger: function renderTrigger() {
            if (initialDisplayThreshold && initialDisplayThreshold < faqs.length) {
                return /* @__PURE__ */ React.createElement(Trigger, {
                    onClick: clickHandler,
                    text: isCollasped ? "".concat(seeMore.primary) : "".concat(seeLess.primary)
                });
            }
            return null;
        }
    };
};
// src/components/frequently-asked-questions/__private/__fragments/question-and-answer.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoListItem } from "uitk-react-expando";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
import { UitkUnformattedHtml, UitkUnformattedHtmlReplaceDefaults } from "uitk-react-unformatted-html";
var __QuestionAndAnswerFragment = gql(_templateObject());
var QuestionAndAnswer = function(param) {
    var data = param.data;
    var question = data.question, answer = data.answer, analytics = data.analytics;
    var track = useClickTracker();
    var paragraphAnswer = "<p>".concat(answer, "</p>");
    var _React2_useState = _slicedToArray(React2.useState(false), 2), isVisible = _React2_useState[0], setIsVisible = _React2_useState[1];
    var answerMarkup = /* @__PURE__ */ React2.createElement(UitkUnformattedHtml, {
        htmlToParse: paragraphAnswer,
        elementsToReplace: _objectSpreadProps(_objectSpread({}, UitkUnformattedHtmlReplaceDefaults), {
            // eslint-disable-next-line react/display-name
            a: function(props) {
                var children = props.children, href = props.href;
                return /* @__PURE__ */ React2.createElement(UitkLink, {
                    inline: true
                }, /* @__PURE__ */ React2.createElement("a", {
                    href: href
                }, children));
            }
        })
    });
    var questionHeading = /* @__PURE__ */ React2.createElement(UitkText, {
        size: 400,
        weight: "bold"
    }, question);
    var onToggle = React2.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible,
        setIsVisible
    ]);
    return /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "one",
            blockend: "two",
            inline: "four"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkExpandoListItem, {
        expandoTitle: questionHeading,
        expandoDescription: answerMarkup,
        isVisible: isVisible,
        onToggle: onToggle,
        analytics: {
            id: "".concat(analytics.referrerId),
            description: "".concat(analytics.linkName),
            callback: function(id, description) {
                return track(id, description);
            }
        }
    })));
};
QuestionAndAnswer.displayName = "QuestionAndAnswer";
QuestionAndAnswer.fragment = __QuestionAndAnswerFragment;
// src/components/frequently-asked-questions/__private/__fragments/faq.tsx
var __FrequentlyAskedQuestionsFragment = gql2(_templateObject1(), QuestionAndAnswer.fragment);
var Faq = function(param) {
    var data = param.data, displayThreshold = param.displayThreshold;
    var title = data.title, questionsAndAnswers = data.questionsAndAnswers, seeMore = data.seeMore, seeLess = data.seeLess;
    var _useCollapsed = useCollapsed(questionsAndAnswers, displayThreshold, seeMore, seeLess), items = _useCollapsed.items, Trigger2 = _useCollapsed.Trigger;
    return /* @__PURE__ */ React3.createElement(UitkCard, null, /* @__PURE__ */ React3.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React3.createElement(UitkHeading, {
        tag: "h2",
        size: 4
    }, title)), /* @__PURE__ */ React3.createElement(UitkExpandoList, null, items.map(function(faq, index) {
        return /* @__PURE__ */ React3.createElement(QuestionAndAnswer, {
            key: "faq-".concat(index),
            data: faq
        });
    })), /* @__PURE__ */ React3.createElement(Trigger2, null));
};
Faq.fragment = __FrequentlyAskedQuestionsFragment;
Faq.displayName = "Faq";
// src/components/frequently-asked-questions/__private/__fragments/faq-structured-data.tsx
import React4 from "react";
import { gql as gql3 } from "@apollo/client";
var __FaqStructuredDataFragment = gql3(_templateObject2());
var FaqStructuredData = function(param) {
    var data = param.data;
    var structuredData = data.seoStructuredData;
    if (!structuredData) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement("script", {
        "data-stid": "faq-structured-data",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: structuredData
        }
    });
};
FaqStructuredData.fragment = __FaqStructuredDataFragment;
FaqStructuredData.displayName = "FaqStructuredData";
// src/components/frequently-asked-questions/frequently-asked-questions.tsx
var __Query = gql4(_templateObject3(), Faq.fragment, FaqStructuredData.fragment);
var FrequentlyAskedQuestions = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, displayThreshold = props.displayThreshold;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var data = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }).data;
    if (!data || !Array.isArray(data.frequentlyAskedQuestions)) {
        return null;
    }
    var frequentlyAskedQuestions = data.frequentlyAskedQuestions;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, frequentlyAskedQuestions.map(function(faq) {
        if (!faq || faq.__typename !== "FrequentlyAskedQuestions") {
            return null;
        }
        return /* @__PURE__ */ React5.createElement(React5.Fragment, {
            key: "faq-".concat(faq.id)
        }, /* @__PURE__ */ React5.createElement(Faq, {
            data: faq,
            displayThreshold: displayThreshold
        }), /* @__PURE__ */ React5.createElement(FaqStructuredData, {
            data: faq
        }));
    }));
};
FrequentlyAskedQuestions.displayName = "FrequentlyAskedQuestions";
export { FrequentlyAskedQuestions };
//# sourceMappingURL=index.js.map